import { useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import Loading from 'components/common/loading';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paths } from '../../config/routes';
import styles from './styles.module.scss';
import { sanitizeUrl } from '@braintree/sanitize-url';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const RedirectParent = () => {
  const navigate = useNavigate();
  const queryParams = useQuery();

  useEffect(() => {
    const redirectTo = sanitizeUrl(queryParams.get('redirect_to') || '');
    if (redirectTo && window.top) {
      window.top.location.href = redirectTo;
    } else {
      Bugsnag.notify(new Error(`Error to redirect to parent, redirect_to: '${redirectTo}'`));
      navigate(Paths.NOT_FOUND);
    }
  }, []);

  return (
    <div className={styles.redirect_parent}>
      <Loading fullScreem noBackground />
    </div>
  );
};

export default RedirectParent;
